
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppFilterGakumonCheck",
  props: {
    optionsGakumon: {
      type: Array,
      required: true,
    },
    gakumonUpdate: {
      type: Array,
      require: true,
      default: null,
    },
  },
  emits: ["update:gakumonUpdate"],
  methods: {
    updateNextValues: function (e: Event) {
      const target = e.target as HTMLInputElement;
      const checked = target.checked;
      const vals = [...this.gakumonUpdate];
      if (checked) {
        [...(target.closest("tr")?.querySelectorAll("td input[type='checkbox']") as NodeListOf<HTMLInputElement>)].forEach((element) => {
          vals.push(element.value);
        });
      } else {
        [...(target.closest("tr")?.querySelectorAll("td input[type='checkbox']") as NodeListOf<HTMLInputElement>)].forEach((element) => {
          vals.splice(vals.indexOf(element.value), 1);
        });
      }
      const uniqueVals = [...new Set(vals)];
      this.$emit("update:gakumonUpdate", uniqueVals);
    },
    updateValue: function (e: Event) {
      const target = e.target as HTMLInputElement;
      const checked = target.checked;
      const val = target.value;
      const vals = [...this.gakumonUpdate];
      if (checked) {
        vals.push(val);
      } else {
        vals.splice(vals.indexOf(val), 1);
      }
      this.$emit("update:gakumonUpdate", vals);
    },
  },
  mounted() {
    /**
     * 学問分野 一括ですべてのチェックボックスをチェック
     * チェックされたものをテキスト表示
     */
    // th 学問系統
    [...(document.querySelectorAll(".c-table__gakumonCheck th input[type='checkbox']") as NodeListOf<HTMLInputElement>)].forEach((element) => {
      element.addEventListener("click", () => {
        if (element?.checked) {
          [...(element.closest("tr")?.querySelectorAll("td input[type='checkbox']") as NodeListOf<HTMLInputElement>)].forEach((element) => {
            element.checked = true;
          });
        } else {
          [...(element.closest("tr")?.querySelectorAll("td input[type='checkbox']") as NodeListOf<HTMLInputElement>)].forEach((element) => {
            element.checked = false;
          });
        }
        CheckedGakumonName();
      });
    });

    // td 学問分野
    [...(document.querySelectorAll(".c-table__gakumonCheck td input[type='checkbox']") as NodeListOf<HTMLInputElement>)].forEach((element) => {
      element.addEventListener("click", () => {
        let allChecked = true; // 学問分野別、全チェックされてるかのフラグ
        [...(element.closest("tr")?.querySelectorAll("td input[type='checkbox']") as NodeListOf<HTMLInputElement>)].forEach((element) => {
          if (element && element.checked != true) {
            allChecked = false;
          }
        });
        if (allChecked) {
          element.closest("tr")!.querySelector<HTMLInputElement>("th input[type='checkbox']")!.checked = true;
        } else {
          element.closest("tr")!.querySelector<HTMLInputElement>("th input[type='checkbox']")!.checked = false;
        }
        CheckedGakumonName();
      });
    });

    function CheckedGakumonName() {
      let checkedText = "";
      [...(document.querySelectorAll(".c-table__gakumonCheck tr") as NodeListOf<HTMLInputElement>)].forEach((element) => {
        if (element.querySelector("th input[type='checkbox']:checked")) {
          // 学問系統全てがチェックされているとき
          let keitouText = element.querySelector("th label")!.textContent;
          keitouText += "(すべて)、";
          checkedText += keitouText;
        } else {
          [...(element.querySelectorAll("td input[type='checkbox']") as NodeListOf<HTMLInputElement>)].forEach((element) => {
            if (element.checked) {
              let bunyaText = element.nextElementSibling!.textContent;
              bunyaText += "、";
              checkedText += bunyaText;
            }
          });
        }
      });
      // 最後の1字を削る(句読点を削る)
      if (checkedText != "") {
        checkedText = checkedText.slice(0, -1);
      }
      document.getElementById("js-checkedText")!.textContent = checkedText;
    }
    // mounted終わり
  },
});
